import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Modal, Alert } from 'react-bootstrap';
import { message } from 'antd';
import AsyncSelect from 'react-select/async';
import ReactSelect from 'react-select';
import polyline from '@mapbox/polyline';
import LoadThongTinService from '../../services/LoadThongTinService';
import ManagerService from '../../services/ManagerService';
import MapPreview from './MapPreview';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/reset.css';

const haversineDistance = (coord1, coord2) => {
  const toRad = (x) => (x * Math.PI) / 180;
  const [lat1, lon1] = coord1;
  const [lat2, lon2] = coord2;
  const R = 6371; // km
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

const RoutePreviewModal = ({
  show,
  onHide,
  origin,
  destination,
  type,
  routePolyline,
  computedDistance,
  onConfirm,
}) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Preview Route</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <MapPreview
          routePolyline={routePolyline}
          originAddress={origin}
          destinationAddress={destination}
        />
        <p className="mt-3">
          <b>Quãng đường đi:</b> {computedDistance ? `${computedDistance} km` : "N/A"}
        </p>
        <p>
          <b>Loại di chuyển:</b> {type || "N/A"} <br />
          <b>Điểm đi:</b> {origin || "N/A"}<br />
          <b>Điểm đến:</b> {destination || "N/A"}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Hủy</Button>
        <Button variant="primary" onClick={onConfirm}>Xác nhận lưu</Button>
      </Modal.Footer>
    </Modal>
  );
};

const TaoDonKinhDoanhComponent = () => {
  const [formData, setFormData] = useState({
    // Trường để tạo đơn công nợ
    don_vi: 'TTKT3',
    username: localStorage.getItem('username') || '50560',

    // Trường để gắn mã hợp đồng
    ma_hd: "",
    
    tenKhachHang: "",
    ngayVanChuyen: "",
    loaiDichVu: "",
    loaiThucHien: "",
    loaiVanChuyen: "", // trường mới: loại vận chuyển
    chiPhiThucHien: "",
    giaBan: "",
    ghiChu: "Không",
    diemDi: "",
    diemDen: "",
    diemDiThucTe: "",
    diemDenThucTe: "",
    diemDiCoord: null,
    diemDenCoord: null,
    loaiKetNoi: "",
    loaiXe: "",
    trongTai: "",
    soLuongChuyen: 1,
    donViTinh: "",
    phuPhi: "",
    chiPhiPhatSinh: 0,
    routing: "",
    ngayKetThucThue: "",
    tenKho: "",
    viTriKho: "",
    viTriKhoCoord: null,
    chiPhiThueKho: "",
    giaThueKho: "",
  });
  const [customers, setCustomers] = useState([]);
  const [contracts, setContracts] = useState([]);
  const [flashMessage, setFlashMessage] = useState("");
  const [showRouteModal, setShowRouteModal] = useState(false);
  const [computedRoute, setComputedRoute] = useState("");
  const [computedDistance, setComputedDistance] = useState("");

  // Lấy danh sách khách hàng
  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await LoadThongTinService.getKhachHang();
        const customerOptions = response.data.map((customer) => ({
          value: customer,
          label: customer,
        }));
        setCustomers(customerOptions);
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    };
    fetchCustomers();
  }, []);

  // Lấy danh sách hợp đồng
  useEffect(() => {
    const fetchContracts = async () => {
      try {
        const response = await ManagerService.getMaHopDong();
        if (response.success) {
          // Giả sử response.data là mảng các đối tượng { ma_khach_hang, ten_don_vi }
          // Ta sẽ map lấy mã hợp đồng (ở đây dùng ma_khach_hang làm mã hợp đồng)
          const options = response.data.map((item) => ({
            value: item.ma_hd,
            label: item.ma_hd,
          }));
          setContracts(options);
        }
      } catch (error) {
        console.error("Error fetching contract codes:", error);
      }
    };
    fetchContracts();
  }, []);

  // Các thông tin vùng, tỉnh thành dùng để tính "loại di chuyển"
  const noiVungProvinces = [
    "Quảng Nam", "Quảng Ngãi", "Bình Định", "Phú Yên", "Khánh Hòa",
    "Ninh Thuận", "Bình Thuận", "Kon Tum", "Gia Lai", "Đắk Lắk", "Đắk Nông", "Lâm Đồng",
    "Bà Rịa-Vũng Tàu", "Bình Dương", "Bình Phước", "Đồng Nai", "Tây Ninh",
    "An Giang", "Bạc Liêu", "Bến Tre", "Cà Mau", "Cần Thơ", "Đồng Tháp",
    "Hậu Giang", "Kiên Giang", "Long An", "Sóc Trăng", "Tiền Giang", "Trà Vinh",
    "Vĩnh Long", "Hồ Chí Minh"
  ]

  useEffect(() => {
    // Hàm async bên trong useEffect
    const fetchRouteData = async () => {
      if (formData.loaiDichVu === "Vận tải" && formData.loaiThucHien === "Đường bộ") {
        const { diemDi, diemDen } = formData;
        if (!diemDi || !diemDen) {
          setFormData(prev => ({ ...prev, loaiKetNoi: "" }));
          return;
        } else {
          if (noiVungProvinces.includes(diemDi) && noiVungProvinces.includes(diemDen)) {
            if (diemDi === diemDen) {
              if (diemDi === "Hồ Chí Minh") {
                setFormData(prev => ({ ...prev, loaiKetNoi: "Nội thành" }));
              } else {
                setFormData(prev => ({ ...prev, loaiKetNoi: "Nội tỉnh" }));
              }
            } else {
              setFormData(prev => ({ ...prev, loaiKetNoi: "Nội vùng" }));
            }
          } else {
            const temp_route = await computeRoute();
            const coords = polyline.decode(temp_route);
            let total = 0;
            for (let i = 1; i < coords.length; i++) {
              total += haversineDistance(coords[i - 1], coords[i]);
            }
            if (total.toFixed(2) >= 300) {
              setFormData(prev => ({ ...prev, loaiKetNoi: "Bắc Nam" }));
            } else {
              setFormData(prev => ({ ...prev, loaiKetNoi: "Nội vùng" }));
            }
          }
        }
      } else {
        setFormData(prev => ({ ...prev, loaiKetNoi: "" }));
      }
    };
  
    // Gọi hàm async
    fetchRouteData();
  }, [formData.diemDi, formData.diemDen, formData.loaiDichVu, formData.loaiThucHien]);

  const handleChange = (field, e) => {
    const value = e.target ? e.target.value : e;
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  // Hàm forward geocoding
  const getCoordinates = async (address) => {
    const apiKey = process.env.REACT_APP_GOONG_API_KEY || "your_goong_api_key";
    const url = `https://rsapi.goong.io/geocode?address=${encodeURIComponent(address)}&api_key=${apiKey}`;
    try {
      const response = await fetch(url);
      const data = await response.json();
      if (data.results && data.results.length > 0) {
        return {'coordinate': data.results[0].geometry.location, 'province': data.results[0].compound.province};
      } else {
        console.error("Không tìm thấy tọa độ cho địa chỉ:", address);
        return null;
      }
    } catch (error) {
      console.error("Geocoding error:", error);
      return null;
    }
  };

  // Hàm loadOptions cho AsyncSelect
  const loadOptions = async (inputValue, field) => {
    if (!inputValue) return [];
    const apiKey = process.env.REACT_APP_GOONG_API_KEY || "your_goong_api_key";
    const url = `https://rsapi.goong.io/Place/AutoComplete?api_key=${apiKey}&input=${encodeURIComponent(inputValue)}`;

    try {
      const response = await fetch(url);
      const data = await response.json();
      if (!data.predictions) return [];

      // Sử dụng filter() để loại bỏ các phần tử không hợp lệ
      const validPredictions = data.predictions.filter(item => 
        item.compound !== null
      );

      // Sau đó sử dụng map() để chuyển đổi các phần tử đã lọc
      return validPredictions.map((item) => ({
        label: item.description,
        value: {
          mainValue: item.structured_formatting?.main_text || "",
          displayValue: item.description || "",
          province: item.compound.province || "",
          location: item.location || null,
        },
      }));
    } catch (error) {
      console.error(`Load options error for ${field}:`, error);
      return [];
    }
  };

  // Xử lý khi chọn địa chỉ từ autocomplete
  const handleSelectChange = async (field, selectedOption) => {
    if (selectedOption) {
      let location = selectedOption.value.location;      
      let province = selectedOption.value.province;
      if (!location || !province) {
        const result = await getCoordinates(selectedOption.value.displayValue);
        if (result) {
          if (result.coordinate != null) {
            location = result.coordinate;
          } 
          if (result.province != null) {
            province = result.province;
          } 
        }               
      }
      if (field === "viTriKho") {
        setFormData((prev) => ({
          ...prev,
          [field]: selectedOption.value.displayValue,
          [`${field}Coord`]: location,
        }));
      } else {
        console.log(field, province)
        setFormData((prev) => ({
          ...prev,
          [field]: province,
          [`${field}ThucTe`]: selectedOption.value.displayValue,
          [`${field}Coord`]: location,
        }));
      }
    } else {
      if (field === "viTriKho") {
        setFormData((prev) => ({ ...prev, [field]: "", [`${field}Coord`]: null }));
      } else {
        setFormData((prev) => ({
          ...prev,
          [field]: "",
          [`${field}ThucTe`]: "",
          [`${field}Coord`]: null,
        }));
      }
    }
  };

  // Hàm tính toán route cho đơn Vận tải (Xe Kinh Doanh)
  const computeRoute = async () => {
    const { diemDiCoord, diemDenCoord } = formData;
    if (!diemDiCoord || !diemDenCoord) {
      message.error("Thiếu tọa độ của điểm đi hoặc điểm đến.");
      return null;
    }
    const origin = `${diemDiCoord.lat},${diemDiCoord.lng}`;
    const destination = `${diemDenCoord.lat},${diemDenCoord.lng}`;
    const apiKey = process.env.REACT_APP_GOONG_API_KEY || "your_goong_api_key";
    const url = `https://rsapi.goong.io/Direction?origin=${origin}&destination=${destination}&vehicle=truck&api_key=${apiKey}`;
    try {
      const response = await fetch(url);
      const data = await response.json();
      if (data.routes && data.routes.length > 0) {
        return data.routes[0].overview_polyline?.points || null;
      } else {
        return null;
      }
    } catch (err) {
      console.error("Compute route error:", err);
      return null;
    }
  };

  useEffect(() => {
    if (computedRoute) {
      const coords = polyline.decode(computedRoute);
      let total = 0;
      for (let i = 1; i < coords.length; i++) {
        total += haversineDistance(coords[i - 1], coords[i]);
      }
      setComputedDistance(total.toFixed(2));
    }
  }, [computedRoute]);

  // Xử lý trường hợp đơn Vận tải (Đường bộ) với Xe Kinh Doanh (cần tính route)
  const handlePreviewRoute = async (e) => {
    e.preventDefault();
    const requiredFields = [
      "tenKhachHang",
      "ngayVanChuyen",
      "loaiDichVu",
      "loaiThucHien",
      "diemDi",
      "diemDen",
      "diemDiThucTe",
      "diemDenThucTe",
      "loaiKetNoi",
      "loaiXe",
      "trongTai",
      "soLuongChuyen",
      "donViTinh",
      "phuPhi",
      "chiPhiThucHien",
      "giaBan",
      "ghiChu",
    ];
    console.log(formData);
    const missing = requiredFields.filter((f) => {
      if (typeof formData[f] === "string") {
        return formData[f].trim() === "";
      }
      return formData[f] === undefined || formData[f] === null;
    });
    if (missing.length > 0) {
      message.error(`Vui lòng nhập đầy đủ thông tin: ${missing.join(", ")}`);
      return;
    }
    const routePolyline = await computeRoute();
    if (!routePolyline) {
      message.error("Không tìm thấy route giữa điểm đi và điểm đến.");
      return;
    }
    setComputedRoute(routePolyline);
    setShowRouteModal(true);
  };

  // Sau khi xem preview route, xác nhận lưu đơn cho Xe Kinh Doanh
  const handleConfirmRouting = async () => {
    const finalFormData = { ...formData, routing: computedRoute };
    try {
      //const response = await ManagerService.submitTaoChuyenKinhDoanh(finalFormData);
      const response = await ManagerService.submitTaoChuyenKinhDoanh(finalFormData);
      if (response.status === 200 && response.data?.message) {
        message.success(response.data.message);
      } else {
        message.error(response.data?.error || "Lỗi không xác định từ server.");
      }
    } catch (error) {
      console.error("Save error:", error);
      message.error("Lỗi khi gửi dữ liệu.");
    }
    setShowRouteModal(false);
  };

  // Xử lý submit cho các đơn khác (FWD, Vận tải với Xe Tổng Công Ty/Xe Thuê ngoài, Kho)
  const handleDirectSubmit = async () => {
    let requiredFields = [];
    if (formData.loaiDichVu === "FWD") {
      requiredFields = ["tenKhachHang", "ngayVanChuyen", "loaiDichVu", "loaiThucHien", "chiPhiThucHien", "giaBan"];
    } else if (formData.loaiDichVu === "Vận tải") {
      if (formData.loaiThucHien === "Đường bộ" && (formData.loaiVanChuyen === "Xe Tổng Công Ty" || formData.loaiVanChuyen === "Xe Thuê ngoài")) {
        requiredFields = ["tenKhachHang", "ngayVanChuyen", "loaiDichVu", "loaiThucHien", "chiPhiThucHien", "giaBan", "ghiChu"];
      } else if (formData.loaiThucHien !== "Đường bộ") {
        requiredFields = ["tenKhachHang", "ngayVanChuyen", "loaiDichVu", "loaiThucHien", "chiPhiThucHien", "giaBan"];
      }
    } else if (formData.loaiDichVu === "Kho") {
      requiredFields = ["tenKhachHang", "ngayVanChuyen", "loaiDichVu", "ngayKetThucThue", "tenKho", "viTriKho", "chiPhiThueKho", "giaThueKho"];
    }
    const missing = requiredFields.filter((f) => {
      if (typeof formData[f] === "string") {
        return formData[f].trim() === "";
      }
      return formData[f] === undefined || formData[f] === null;
    });
    if (missing.length > 0) {
      message.error(`Vui lòng nhập đầy đủ thông tin: ${missing.join(", ")}`);
      return;
    }
    const finalFormData = { ...formData };
    try {
      const response = await ManagerService.submitTaoChuyenKinhDoanh(finalFormData);
      if (response.status === 200 && response.data?.message) {
        message.success(response.data.message);
      } else {
        message.error(response.data?.error || "Lỗi không xác định từ server.");
      }
    } catch (error) {
      console.error("Save error:", error);
      message.error("Lỗi khi gửi dữ liệu.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Với Vận tải - Đường bộ: nếu là Xe Kinh Doanh thì tính route, ngược lại xử lý trực tiếp.
    if (formData.loaiDichVu === "Vận tải" && formData.loaiThucHien === "Đường bộ") {
      if (formData.loaiVanChuyen === "Xe Kinh Doanh") {
        await handlePreviewRoute(e);
      } else {
        await handleDirectSubmit();
      }
    } else {
      await handleDirectSubmit();
    }
  };

  return (
    <Container className="my-4">
      <h2 className="text-center mb-4">Tạo Đơn Kinh Doanh</h2>
      {flashMessage && (
        <Alert variant={flashMessage.includes("Lỗi") ? "danger" : "success"}>
          {flashMessage}
        </Alert>
      )}
      <Form onSubmit={handleSubmit}>
        {/* Thông tin khách hàng và ngày thực hiện */}
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="tenKhachHang">
              <Form.Label>Tên khách hàng</Form.Label>
              <ReactSelect
                name="tenKhachHang"
                options={customers}
                placeholder="Tìm và chọn khách hàng..."
                isClearable
                onChange={(opt) =>
                  setFormData((prev) => ({ ...prev, tenKhachHang: opt ? opt.value : "" }))
                }
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="ngayVanChuyen">
              <Form.Label>Ngày thực hiện</Form.Label>
              <Form.Control
                type="date"
                name="ngayVanChuyen"
                value={formData.ngayVanChuyen}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, ngayVanChuyen: e.target.value }))
                }
                required
              />
            </Form.Group>
          </Col>
        </Row>
        
        {/* Chọn Loại dịch vụ và Loại thực hiện */}
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="loaiDichVu">
              <Form.Label>Loại dịch vụ</Form.Label>
              <Form.Select
                name="loaiDichVu"
                value={formData.loaiDichVu}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    loaiDichVu: e.target.value,
                    loaiThucHien: "",
                    loaiVanChuyen: "",
                  }))
                }
                required
              >
                <option value="" disabled>
                  Chọn loại dịch vụ
                </option>
                <option value="FWD">FWD</option>
                <option value="Vận tải">Vận tải</option>
                <option value="Kho">Kho</option>
              </Form.Select>
            </Form.Group>
          </Col>
          {(formData.loaiDichVu === "FWD" || formData.loaiDichVu === "Vận tải") && (
            <Col md={6}>
              <Form.Group controlId="loaiThucHien">
                <Form.Label>Loại thực hiện</Form.Label>
                <Form.Select
                  name="loaiThucHien"
                  value={formData.loaiThucHien}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      loaiThucHien: e.target.value,
                    }))
                  }
                  required
                >
                  <option value="" disabled>
                    Chọn loại thực hiện
                  </option>
                  {formData.loaiDichVu === "FWD" && (
                    <>
                      <option value="FWD đường thủy">FWD đường thủy</option>
                      <option value="FWD đường bay">FWD đường bay</option>
                    </>
                  )}
                  {formData.loaiDichVu === "Vận tải" && (
                    <>
                      <option value="Đường biển">Đường biển</option>
                      <option value="Đường hàng không">Đường hàng không</option>
                      <option value="Đường sắt">Đường sắt</option>
                      <option value="Đường bộ">Đường bộ</option>
                    </>
                  )}
                </Form.Select>
              </Form.Group>
            </Col>
          )}
        </Row>
        {/* Các đơn FWD */}
        {formData.loaiDichVu === "FWD" && (
          <>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="chiPhiThucHien">
                  <Form.Label>Chi phí thực hiện dịch vụ (VNĐ)</Form.Label>
                  <Form.Control
                    type="text"
                    name="chiPhiThucHien"
                    value={formData.chiPhiThucHien}
                    onChange={(e) => handleChange("chiPhiThucHien", e)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="giaBan">
                  <Form.Label>Giá bán dịch vụ (VNĐ)</Form.Label>
                  <Form.Control
                    type="text"
                    name="giaBan"
                    value={formData.giaBan}
                    onChange={(e) => handleChange("giaBan", e)}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <Form.Group controlId="ghiChu">
                  <Form.Label>Ghi chú</Form.Label>
                  <Form.Control
                    type="text"
                    name="ghiChu"
                    value={formData.ghiChu}
                    onChange={(e) => handleChange("ghiChu", e)}
                  />
                </Form.Group>
              </Col>
            </Row>
          </>
        )}
        {/* Đơn Vận tải */}
        {formData.loaiDichVu === "Vận tải" && formData.loaiThucHien !== "Đường bộ" && (
          <>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="chiPhiThucHien">
                  <Form.Label>Chi phí thực hiện dịch vụ (VNĐ)</Form.Label>
                  <Form.Control
                    type="number"
                    name="chiPhiThucHien"
                    value={formData.chiPhiThucHien}
                    onChange={(e) => handleChange("chiPhiThucHien", e)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="giaBan">
                  <Form.Label>Giá bán dịch vụ (VNĐ)</Form.Label>
                  <Form.Control
                    type="number"
                    name="giaBan"
                    value={formData.giaBan}
                    onChange={(e) => handleChange("giaBan", e)}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <Form.Group controlId="ghiChu">
                  <Form.Label>Ghi chú</Form.Label>
                  <Form.Control
                    type="text"
                    name="ghiChu"
                    value={formData.ghiChu}
                    onChange={(e) => handleChange("ghiChu", e)}
                  />
                </Form.Group>
              </Col>
            </Row>
          </>
        )}
        {/* Đơn Vận tải - Đường bộ */}
        {formData.loaiDichVu === "Vận tải" && formData.loaiThucHien === "Đường bộ" && (
          <>
            {/* Hiển thị trường chọn loại vận chuyển */}
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="loaiVanChuyen">
                  <Form.Label>Loại vận chuyển</Form.Label>
                  <Form.Select
                    name="loaiVanChuyen"
                    value={formData.loaiVanChuyen}
                    onChange={(e) => handleChange("loaiVanChuyen", e)}
                    required
                  >
                    <option value="" disabled>
                      Chọn loại vận chuyển
                    </option>
                    <option value="Xe Kinh Doanh">Xe Kinh Doanh</option>
                    <option value="Xe Tổng Công Ty">Xe Tổng Công Ty</option>
                    <option value="Xe Thuê ngoài">Xe Thuê ngoài</option>
                  </Form.Select>
                </Form.Group>
              </Col>        
              <Col md={6}>
                <Form.Group controlId="soLuongChuyen">
                  <Form.Label>Số lượng chuyến: </Form.Label>
                  <Form.Control
                    type="number"
                    name="soLuongChuyen"
                    value={formData.soLuongChuyen}
                    onChange={(e) => handleChange("soLuongChuyen", e)}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            {formData.loaiVanChuyen === "Xe Kinh Doanh" ? (
              <>
                {/* Hiển thị đầy đủ các trường định tuyến */}
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group controlId="diemDi">
                      <Form.Label>Điểm đi</Form.Label>
                      <AsyncSelect
                        cacheOptions
                        loadOptions={(input) => loadOptions(input, "diemDi")}
                        onChange={(opt) => handleSelectChange("diemDi", opt)}
                        placeholder="Chọn điểm đi từ gợi ý..."
                        isClearable
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="diemDen">
                      <Form.Label>Điểm đến</Form.Label>
                      <AsyncSelect
                        cacheOptions
                        loadOptions={(input) => loadOptions(input, "diemDen")}
                        onChange={(opt) => handleSelectChange("diemDen", opt)}
                        placeholder="Chọn điểm đến từ gợi ý..."
                        isClearable
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group controlId="loaiXe">
                      <Form.Label>Loại xe</Form.Label>
                      <Form.Select
                        name="loaiXe"
                        value={formData.loaiXe}
                        onChange={(e) => handleChange("loaiXe", e)}
                        required
                      >
                        <option value="" disabled>
                          Chọn loại xe
                        </option>
                        <option value="Khô">Khô</option>
                        <option value="Lạnh">Lạnh</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group controlId="trongTai">
                      <Form.Label>Trọng tải (Kg)</Form.Label>
                      <Form.Select
                        name="trongTai"
                        value={formData.trongTai}
                        onChange={(e) => handleChange("trongTai", e)}
                        required
                      >
                        <option value="" disabled>
                          Chọn trọng tải
                        </option>
                        {[830, 900, 1250, 1650, 1900, 1995, 2500, 3500, 3900, 4500, 4995, 5100, 5300, 5400, 6500, 6600, 8000, 13000, 17900, 'Container'].map((w, idx) => (
                          <option key={idx} value={w}>
                            {w}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    <Form.Group controlId="donViTinh">
                      <Form.Label>Đơn vị tính</Form.Label>
                      <Form.Select
                        name="donViTinh"
                        value={formData.donViTinh}
                        onChange={(e) => handleChange("donViTinh", e)}
                        required
                      >
                        <option value="" disabled>
                          Chọn đơn vị tính
                        </option>
                        <option value="Khối">Khối</option>
                        <option value="Kiện">Kiện</option>
                        <option value="Chuyến">Chuyến</option>
                        <option value="Tấn">Tấn</option>
                        <option value="Km">Km</option>
                        <option value="CR">CR</option>
                        <option value="Pallet">Pallet</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group controlId="phuPhi">
                      <Form.Label>Phụ phí</Form.Label>
                      <Form.Select
                        name="phuPhi"
                        value={formData.phuPhi}
                        onChange={(e) => handleChange("phuPhi", e)}
                        required
                      >
                        <option value="" disabled>
                          Chọn phụ phí
                        </option>
                        <option value="Không có" default>Không có</option>
                        <option value="Bốc xếp">Bốc xếp</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="chiPhiThucHien">
                      <Form.Label>Chi phí bốc xếp (VNĐ)</Form.Label>
                      <Form.Control
                        type="number"
                        name="chiPhiThucHien"
                        defaultValue={0}
                        value={formData.chiPhiThucHien}
                        onChange={(e) => handleChange("chiPhiThucHien", e)}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={4}>
                    <Form.Group controlId="giaBan">
                      <Form.Label>Giá bán dịch vụ (VNĐ)</Form.Label>
                      <Form.Control
                        type="text"
                        name="giaBan"
                        value={formData.giaBan}
                        onChange={(e) => handleChange("giaBan", e)}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group controlId="chiPhiPhatSinh">
                      <Form.Label>Chi phí phát sinh</Form.Label>
                      <Form.Control
                        type="number"
                        name="chiPhiPhatSinh"
                        defaultValue={0}
                        value={formData.chiPhiPhatSinh}
                        onChange={(e) => handleChange("chiPhiPhatSinh", e)}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group controlId="ghiChu">
                      <Form.Label>Ghi chú</Form.Label>
                      <Form.Control
                        type="text"
                        name="ghiChu"
                        value={formData.ghiChu}
                        onChange={(e) => handleChange("ghiChu", e)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </>
            ) : (
              // Nếu không phải Xe Kinh Doanh (tức là Xe Tổng Công Ty hoặc Xe Thuê ngoài)
              <>
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group controlId="chiPhiThucHien">
                      <Form.Label>Chi phí thực hiện dịch vụ (VNĐ)</Form.Label>
                      <Form.Control
                        type="text"
                        name="chiPhiThucHien"
                        value={formData.chiPhiThucHien}
                        onChange={(e) => handleChange("chiPhiThucHien", e)}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="giaBan">
                      <Form.Label>Giá bán dịch vụ (VNĐ)</Form.Label>
                      <Form.Control
                        type="text"
                        name="giaBan"
                        value={formData.giaBan}
                        onChange={(e) => handleChange("giaBan", e)}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <Form.Group controlId="ghiChu">
                      <Form.Label>Ghi chú</Form.Label>
                      <Form.Control
                        type="text"
                        name="ghiChu"
                        value={formData.ghiChu}
                        onChange={(e) => handleChange("ghiChu", e)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}
          </>
        )}
        {formData.loaiDichVu === "Kho" && (
          <>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="ngayKetThucThue">
                  <Form.Label>Ngày kết thúc thuê</Form.Label>
                  <Form.Control
                    type="date"
                    name="ngayKetThucThue"
                    value={formData.ngayKetThucThue}
                    onChange={(e) => handleChange("ngayKetThucThue", e)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="tenKho">
                  <Form.Label>Tên kho</Form.Label>
                  <Form.Control
                    type="text"
                    name="tenKho"
                    value={formData.tenKho}
                    onChange={(e) => handleChange("tenKho", e)}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="viTriKho">
                  <Form.Label>Vị trí kho</Form.Label>
                  <AsyncSelect
                    cacheOptions
                    loadOptions={(input) => loadOptions(input, "viTriKho")}
                    onChange={(opt) => handleSelectChange("viTriKho", opt)}
                    placeholder="Chọn vị trí kho từ gợi ý..."
                    isClearable
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="chiPhiThueKho">
                  <Form.Label>Chi phí thực hiện thuê kho (VNĐ)</Form.Label>
                  <Form.Control
                    type="text"
                    name="chiPhiThueKho"
                    value={formData.chiPhiThueKho}
                    onChange={(e) => handleChange("chiPhiThueKho", e)}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="giaThueKho">
                  <Form.Label>Giá cho thuê kho (VNĐ)</Form.Label>
                  <Form.Control
                    type="text"
                    name="giaThueKho"
                    value={formData.giaThueKho}
                    onChange={(e) => handleChange("giaThueKho", e)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="ghiChu">
                  <Form.Label>Ghi chú</Form.Label>
                  <Form.Control
                    type="text"
                    name="ghiChu"
                    value={formData.ghiChu}
                    onChange={(e) => handleChange("ghiChu", e)}
                  />
                </Form.Group>
              </Col>
            </Row>
          </>
        )}
        <Button type="submit" variant="warning" block>
          {formData.loaiDichVu === "Vận tải" && formData.loaiThucHien === "Đường bộ"
            ? formData.loaiVanChuyen === "Xe Kinh Doanh"
              ? "Xác nhận hiển thị đường đi"
              : "Lưu đơn"
            : "Lưu đơn"}
        </Button>
      </Form>

      <RoutePreviewModal
        show={showRouteModal}
        onHide={() => setShowRouteModal(false)}
        origin={formData.diemDiThucTe}
        destination={formData.diemDenThucTe}
        type={formData.loaiKetNoi}
        routePolyline={computedRoute}
        computedDistance={computedDistance}
        onConfirm={handleConfirmRouting}
      />
    </Container>
  );
};

export default TaoDonKinhDoanhComponent;
